/** `worker` over `items` with at most `limit` running at once; results keep input order. */
export const mapWithConcurrency = async <T, R>(
  items: T[],
  limit: number,
  worker: (item: T) => Promise<R>
): Promise<R[]> => {
  const results: R[] = new Array(items.length);
  let next = 0;
  // Each runner drains the queue one item at a time; `limit` runners share it.
  const run = async () => {
    while (next < items.length) {
      const at = next;
      next += 1;
      // eslint-disable-next-line no-await-in-loop -- sequential by design
      results[at] = await worker(items[at]);
    }
  };
  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, run));
  return results;
};
